import {
  BROKER_FAV_DATA,
  CHART_DATA,
  IS_ERROR,
  IS_LOADING,
  RELOADED_TIME,
  SELECT_BROKER_NUMBER,
  SELECT_CHART_TICKER,
  SELECT_CHART_TYPE,
  SELECT_DATE_BY,
  SELECT_VIEW_BY,
} from '../../redux/BrokerFavorites/ActionTypes';
import { message } from 'antd';
import axiosOrder from '../../axios';

const reducer = (state = {
  loading: false,
  brokerNumber: '1',
  viewBy: 'Quantity',
  resultDate: 1,
  reloadedTime: '',
  data: { buy: [], sell: [] },
  error: 'Cannot Load Data',
  chartType: 'buyTotalQuantity',
  selectedChartTicker: '',
  chartData: {},
}, action: { type: string; data: any; message: string; }) => {
  switch (action.type) {
  case SELECT_BROKER_NUMBER:
    return {
      ...state,
      brokerNumber: action.data,
    }
  case CHART_DATA:
    return {
      ...state,
      chartData: action.data,
    }
  case SELECT_VIEW_BY:
    return {
      ...state,
      viewBy: action.data,
    }
  case SELECT_CHART_TICKER:
    return {
      ...state,
      selectedChartTicker: action.data,
    }
  case SELECT_DATE_BY:
    return {
      ...state,
      resultDate: action.data,
    }
  case RELOADED_TIME:
    return {
      ...state,
      reloadedTime: action.data,
    }
  case SELECT_CHART_TYPE:
    return {
      ...state,
      chartType: action.data,
    }

    // for async data
  case IS_LOADING:
    return {
      ...state,
      loading: true,
    }
  case BROKER_FAV_DATA:
    return {
      ...state,
      loading: false,
      data: action.data,
    }
  case IS_ERROR:
    return {
      ...state,
      loading: false,
      error: action.message,
    }
  default:
    return state
  }
}

const getBrokerFavData = (data: any) => ({
  type: BROKER_FAV_DATA,
  data,
})

const setReloadedTime = (data: string) => ({
  type: RELOADED_TIME,
  data,
})
const getChartData = (data: any) => ({
  type: CHART_DATA,
  data,
})

export const selectChartTicker = (data: any) => ({
  type: SELECT_CHART_TICKER,
  data,
})

const Loading = () => ({ type: IS_LOADING })
const Error = () => ({ type: IS_ERROR })

// eslint-disable-next-line max-len
export const loadBrokerFav = (broker: string, type: string, date: string, showLoading: boolean) => async (dispatch: (arg0: { type: string; data?: any; }) => void) => {
  if (showLoading) dispatch(Loading());
  try {
    const { data: { data, reloadedTime } } = await axiosOrder.get('/systemx/dalalstreet/getBrokerFavorites',
      {
        params: {
          broker,
          type,
          date,
        },
      });
    var _data, _data$buy$;
    const initTicker = ((_data = data) === null || _data === void 0 ? void 0 : (_data$buy$ = _data.buy[0]) === null || _data$buy$ === void 0 ? void 0 : _data$buy$.ticker) || '';
    dispatch(selectChartTicker(initTicker));
    dispatch(getBrokerFavData(data));
    dispatch(setReloadedTime(reloadedTime));
  } catch (e) {
    message.error('Cannot load Broker Favorites. Try again');
    dispatch(Error());
  }
}

export const loadBrokerFavChart = (ticker: string,
  broker: string,
  type: string) => async (dispatch: (arg0: { type: string; data: any; }) => void) => {
  try {
    const { data } = await axiosOrder.get('/systemx/dalalstreet/getBrokerFavChart', {
      params: {
        ticker,
        broker,
        type,
      },
    })
    dispatch(getChartData(data));
  } catch (ex) {
    message.error('Cannot load chart data');
    dispatch(getChartData([]));
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/BrokerFavorites/BrokerActions.ts